import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClickOutsideDirective} from './click-outside.directive';
import {SelectOnClickDirective} from './select-on-click.directive';
import {ClickOutsideEventDirective} from './click-outside-event.directive';
import {ImageDefaultDirective} from './image-default.directive';
import {HasRoleDirective} from './has-role.directive';
import {ViewModeDirective} from '../../shared/components/editable/view-mode.directive';
import {EditModeDirective} from '../../shared/components/editable/edit-mode.directive';
import {BorderErrorDirective} from './border-error.directive';
import {NoWhitespaceDirective} from './no-whitespace.directive';
import {MarkWithAsteriskDirective} from './mark-with-asterisk.directive';
import {ToggleVisibleDirective} from './toggle-visible.directive';
import {FormatPhoneDirective} from './format-phone.directive';
import {TrimDirective} from './trim-value-accessor.directive';
import {DateOfBirthDirective} from './date-of-birth.directive';

@NgModule({
  declarations: [
    ClickOutsideDirective,
    SelectOnClickDirective,
    ClickOutsideEventDirective,
    ImageDefaultDirective,
    HasRoleDirective,
    ViewModeDirective,
    EditModeDirective,
    BorderErrorDirective,
    NoWhitespaceDirective,
    MarkWithAsteriskDirective,
    ToggleVisibleDirective,
    FormatPhoneDirective,
    TrimDirective,
    DateOfBirthDirective,
  ],
  imports: [CommonModule],
  exports: [
    ClickOutsideDirective,
    SelectOnClickDirective,
    ClickOutsideEventDirective,
    ImageDefaultDirective,
    HasRoleDirective,
    ViewModeDirective,
    EditModeDirective,
    BorderErrorDirective,
    NoWhitespaceDirective,
    MarkWithAsteriskDirective,
    ToggleVisibleDirective,
    FormatPhoneDirective,
    TrimDirective,
    DateOfBirthDirective,
  ],
})
export class DirectivesModule {}
